﻿import $ from "./dQuery";
import debounce from "lodash/debounce";

declare var checkoutItems: any;
declare var gtag: Function;
declare var StripeCheckout: any;

$(function() {
    const form: HTMLFormElement = document.forms["orderForm"];

    if (!!form) {
        const price = parseFloat(form.dataset.price as string);
        const seatsElement = form.elements["Details.Seats"];
        const volumeDiscounts: { [volume: string]: number; } = !seatsElement ? {} : JSON.parse(seatsElement.dataset.discounts);
        const periodsRadioElements = form.querySelectorAll('input[name="Details.PrepayPeriods"]');
        const countryElement = form.elements["Country"];

        const update = function () {
            const volume = !seatsElement ? 1 : parseInt(seatsElement.value, 10);
            const qualifiedDiscounts = Object.keys(volumeDiscounts)
                .map(l => parseInt(l, 10))
                .filter(l => volume >= l)
                .sort((a, b) => a < b ? -1 : a === b ? 0 : 1)
                .reverse();

            let periodLength = 1,
                periodDiscount = 0,
                periodDiscountItemAmount = 0;
            if (periodsRadioElements.length > 0) {
                const selectedPeriodElement = form.querySelector('input[name="Details.PrepayPeriods"]:checked') as HTMLInputElement;
                periodDiscount = parseFloat(selectedPeriodElement.dataset.discount as string);
                periodLength = parseFloat(selectedPeriodElement.value);
                periodDiscountItemAmount = -price * periodLength * periodDiscount;
            }

            const volumeDiscount = qualifiedDiscounts.length > 0 ? volumeDiscounts[qualifiedDiscounts[0]] : 0;
            const volumeDiscountItemAmount = -price * periodLength * volumeDiscount;

            $(".volume-discount-percentage").text((volumeDiscount * 100).toFixed(0));
            $('.volume-discount-item').text(volumeDiscountItemAmount.toFixed(2));
            $(".volume-discount-total").text((volumeDiscountItemAmount * volume).toFixed(2));
            $(".volume-discount-row").toggleClass("hidden", volumeDiscount === 0);

            $(".period-discount-percentage").text((periodDiscount * 100).toFixed(0));
            $(".period-discount-item").text(periodDiscountItemAmount.toFixed(2));
            $(".period-discount-total").text((periodDiscountItemAmount * volume).toFixed(2));
            $(".period-discount-row").toggleClass("hidden", periodDiscount === 0);
            $(".years").text(periodLength);

            $(".quantity").text(volume);
            $(".price-license").text((price * volume * periodLength).toFixed(2));
            $(".price-item").text((price * periodLength).toFixed(2));

            const totalBeforeVAT = ((price * periodLength) + volumeDiscountItemAmount + periodDiscountItemAmount) * volume;

            const vatRate = countryElement.value.toUpperCase() === "NO" ? 0.25 : 0;
            $('.vat-row').toggleClass("hidden", vatRate === 0);
            $('.vat-rate').text((vatRate * 100).toFixed(0));
            const vatAmount = totalBeforeVAT * vatRate;
            $('.vat-amount').text(vatAmount.toFixed(2));

            $('.total').text((totalBeforeVAT + vatAmount).toFixed(2));

            var items = [checkoutItems[0]];
            items[0].quantity = volume;
            if (periodDiscount > 0) {
                items.push({
                    "id": "period-discount",
                    "name": $('.period-discount-text').elements[0].innerText,
                    "category": "Discount",
                    "quantity": volume,
                    "price": periodDiscountItemAmount.toFixed(2)
                });
            }

            if (volumeDiscount > 0) {
                items.push({
                    "id": "volume-discount",
                    "name": $('.volume-discount-text').elements[0].innerText,
                    "category": "Discount",
                    "quantity": volume,
                    "price": volumeDiscountItemAmount.toFixed(2)
                });
            }

            gtag('event', 'checkout_progress',
                {
                    items: checkoutItems,
                    checkout_step: 1,
                    currency: "EUR",
                    tax: vatAmount.toFixed(),
                    value: (totalBeforeVAT + vatAmount).toFixed(2)
                });
        };
        const debouncedUpdate = debounce(update, 50);

        let elements = [];
        elements = elements.concat(Array.prototype.slice.call(periodsRadioElements));
        elements.push(countryElement);

        if (!!seatsElement) {
            elements.push(seatsElement);
        }
        $(elements)
            .on("change", debouncedUpdate)
            .on("keyup", debouncedUpdate)
            .on("click", debouncedUpdate)
            .on("blur", debouncedUpdate);

        update();
    }
});